﻿import { ajaxGet, ajaxPost, ajaxPostWithJSON } from '../../utils/ajax';
export default {
    getTeliaContracts(orderId, documentId, dealerCode, channelType, fileName, callback, errorCallback) {
        var url = "/teliadk/AjaxHandlerDigitalValidation/GetDocumentAsync?orderId=" +
            orderId +
            "&documentId=" +
            documentId +
            "&dealerCode=" +
            dealerCode +
            "&channelType=" +
            channelType +
            "&fileName=" +
            fileName;
        ajaxGet(url, true, true)
            .then(callback)
            .catch(errorCallback);
    },
    signPortings(existingPortings, callback, errorCallback) {
        var url = "/teliadk/AjaxHandlerDigitalValidation/SignBusinessPortingsAsync";
        ajaxPostWithJSON(url, existingPortings)
                .then(callback)
                .catch(errorCallback);
    },
    uploadDocumentPdf(requestData, callback, errorCallback) {
        var url = "/teliadk/PortingB2CDigitalValidationModuleBlock/UploadDocumentPdfAsync";           
        ajaxPostWithJSON(url, requestData)
                .then(callback)
                .catch(errorCallback);
    },
    signNonPortingContracts(orderId, dealerCode, channelType, callback, errorCallback) {
        var url = "/teliadk/AjaxHandlerDigitalValidation/SignNonPortingContractsAsync?orderId=" +
            orderId +
            "&dealerCode=" +
            dealerCode +
            "&channelType=" +
            channelType; 
        ajaxPost(url)
                .then(callback)
                .catch(errorCallback);
    },
    approveOrderByCustomer(orderId, dealerCode, channelType, callback, errorCallback) {
        var url = "/teliadk/AjaxHandlerDigitalValidation/ApproveOrderByCustomerAsync?orderId=" +
            orderId +
            "&dealerCode=" +
            dealerCode +
            "&channelType=" +
            channelType; 
        ajaxPost(url)
                .then(callback)
                .catch(errorCallback);
    },
    getDocumentsPdf(orderId, dealerCode, channelType, teliaFinanceContracts, fileName, callback, errorCallback) {
        var url = "/teliadk/AjaxHandlerDigitalValidation/GetCombinedPrivateContractsAsync?orderId=" +
            orderId +
            "&teliaFinanceContracts=" +
            teliaFinanceContracts +
            "&dealerCode=" +
            dealerCode +
            "&channelType=" +
            channelType +
            "&fileName=" +
            fileName;
        ajaxGet(url, true, true)
            .then(callback)
            .catch(errorCallback);
    },
    signPortingsBtC(existingPortings, callback, errorCallback) {
        var url = "/teliadk/AjaxHandlerDigitalValidation/SignPrivatePortingsAsync";
        ajaxPostWithJSON(url, existingPortings)
                .then(callback)
                .catch(errorCallback);
    },
    signDocumentsBtC(orderId, dealerCode, channelType, callback, errorCallback) {
        var url = "/teliadk/AjaxHandlerDigitalValidation/SignNonPortingContractsAsync?orderId=" +
            orderId +
            "&dealerCode=" +
            dealerCode +
            "&channelType=" +
            channelType; 
        ajaxPost(url)
                .then(callback)
                .catch(errorCallback);
    },
    approveOrderBtC(orderId, dealerCode, channelType, callback, errorCallback) {
        var url = "/teliadk/AjaxHandlerDigitalValidation/ApproveOrderByCustomerAsync?orderId=" +
            orderId +
            "&dealerCode=" +
            dealerCode +
            "&channelType=" +
            channelType;  
        ajaxPost(url)
                .then(callback)
                .catch(errorCallback);
    }
}